import { useParams } from 'react-router-dom';
import logo from '../assets/VibeChecker.svg';
import './Design.css'

import DesignCard from '../components/DesignCard';

import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';

import { createClient } from '@supabase/supabase-js'
import { useEffect, useState } from 'react';

const supabaseUrl = 'https://hsqjrdifsnxrkwyehhey.supabase.co'
const supabaseKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImhzcWpyZGlmc254cmt3eWVoaGV5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mjk2NDgxMTQsImV4cCI6MjA0NTIyNDExNH0.PACJoo6iCmukz6LXGtDCfKwv2dUfzv1rI3FWw1DD3P0'
const supabase = createClient(supabaseUrl, supabaseKey)

const { v4: uuidv4 } = require('uuid');

export const Design = () => {
    let { design_id } = useParams();

    const [design, setDesign] = useState(undefined);
    const [vibeChecks, setVibeChecks] = useState(undefined);

    const [forceUpdate, setForceUpdate] = useState(0);

    const loadDesign = async () => {
        const { data } = await supabase
            .from('designs') // Replace with your table name
            .select('*') // Select all columns (or specify specific ones)
            .eq('id', design_id) // Filter by the ID
            .single();
        console.log(data);
        setDesign(data);
    }

    const loadVibeChecks = async () => {
        const { data } = await supabase
            .from('vibe_checks') // Replace with your table name
            .select('*') // Select all columns (or specify specific ones)
            .eq('design_id', design_id)
            .order('created_at', { descending: true }) // Filter by the ID
        console.log('vibeChecks' + data);
        console.log(data);
        setVibeChecks(data);
    }

    const buyStats = async () => {
        await supabase
            .from('stats')
            .insert([
                {
                    id: uuidv4(),
                    what: 'buy'
                }
            ])
    }

    useEffect(() => {
        loadDesign();
        loadVibeChecks();
    }, [])

    const navigate = useNavigate();
    return (
        <div className="Design">
            <header className="Design-header">
                <div className='design-top'>
                    <img src={logo} className="design-logo" alt="logo" />
                    <div className='design-buy-btn' onClick={() => {
                        buyStats()
                    }}>Buy VibeChecks</div>
                </div>
                {design &&
                    <div className='design-container'>
                        <div className='design-image'>
                            {design &&
                                <DesignCard design={design} />
                            }
                        </div>
                        <div className='design-image'>
                            <div className='design-info-top'>
                                <div className='design-rating'>
                                    {design.credits} credits
                                </div>
                                <div className='design-rating'>
                                    {design.vibe_checks_num} VibeChecks
                                </div>
                                <div className='design-rating'>
                                    {design.rates_sum > 0 &&
                                        <>
                                            {design.rates_sum / design.vibe_checks_num} Rating
                                        </>
                                    }
                                </div>
                            </div>
                            <div className='design-vibe-checks'>
                                {vibeChecks &&
                                    <>
                                        {vibeChecks.map((data) => {
                                            console.log('doing')
                                            console.log(data)
                                            return (
                                                <div className='design-vibe-check'>
                                                    <div className='design-rating'>
                                                        {data.vibe}
                                                    </div>
                                                    <div className='design-rating'>
                                                        {data.rate}
                                                    </div>
                                                </div>
                                            )
                                        })}
                                    </>
                                }
                            </div>
                            <div className='design-more-btn' onClick={() => navigate(`/review/${design_id}`)}>
                                Earn More Credits
                            </div>
                        </div>
                    </div>
                }
            </header>
        </div>
    )
}

export default Design